import React, { useEffect, useRef } from 'react';
import MenuItems from '../data/MenuItems';
import MainLayout from '../layouts/main/MainLayout';
import StartNowSection from '../components/sections/StartNowSection';
import FootballClubsSection from '../components/sections/FootballClubsSection';
import WhoWeAreSection from '../components/sections/WhoWeAreSection';
import ExperiencesSection from '../components/sections/ExperiencesSection';
import BenefitsSection from '../components/sections/BenefitsSection';
// import OurLadsSection from '../components/sections/OurLadsSection';
import OurAppSection from '../components/sections/OurAppSection';
import RetailSection from '../components/sections/RetailSection';
import Seo from '../components/Seo';

const IndexPage = () => {
    const startNowSectionRef = useRef(null);
    const whoWeAreSectionRef = useRef(null);
    const experiencesSectionRef = useRef(null);
    const benefitsSectionRef = useRef(null);
    // const ourLadsSectionRef = useRef(null);
    const ourAppSectionRef = useRef(null);
    // const retailSectionRef = useRef(null);

    useEffect(() => {
        const sectionRefs = [
            { section: MenuItems.startNow.id, ref: startNowSectionRef },
            { section: MenuItems.whoWeAre.id, ref: whoWeAreSectionRef },
            { section: MenuItems.experiences.id, ref: experiencesSectionRef },
            // { section: MenuItems.ourLads.id, ref: ourLadsSectionRef },
            { section: MenuItems.ourApp.id, ref: ourAppSectionRef },
            { section: MenuItems.benefits.id, ref: benefitsSectionRef },
            // { section: MenuItems.retail.id, ref: retailSectionRef },
        ];
        let visibleSection = null;

        const setSectionWithActiveClass = (section, addActiveClass = true) => {
            const navElement = document.querySelector(`a[href="/#${section}"]`);

            if (addActiveClass) {
                if (!navElement.classList.contains('active')) {
                    navElement.classList.add('active');
                }
            } else {
                if (navElement.classList.contains('active')) {
                    navElement.classList.remove('active');
                }
            }
        };

        const getDimensions = (ele) => {
            const { height } = ele.getBoundingClientRect();
            const offsetTop = ele.offsetTop;
            const offsetBottom = offsetTop + height;

            return {
                height,
                offsetTop,
                offsetBottom,
            };
        };

        const handleScroll = () => {
            const scrollPosition = window.scrollY + 150;
            const selected = sectionRefs.find(({ section, ref }) => {
                const element = ref.current;
                if (element) {
                    const { offsetBottom, offsetTop } = getDimensions(element);
                    return (
                        scrollPosition > offsetTop &&
                        scrollPosition < offsetBottom
                    );
                }

                return null;
            });

            if (selected && selected.section !== visibleSection) {
                visibleSection = selected.section;
                sectionRefs.forEach((sectionRef) => {
                    setSectionWithActiveClass(sectionRef.section, false);
                });

                setSectionWithActiveClass(visibleSection, true);
            }
        };

        setSectionWithActiveClass(sectionRefs[0].section, true);
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <MainLayout>
            <Seo />
            <StartNowSection
                id={MenuItems.startNow.id}
                ref={startNowSectionRef}
            />
            <FootballClubsSection />
            <WhoWeAreSection
                id={MenuItems.whoWeAre.id}
                ref={whoWeAreSectionRef}
            />
            <ExperiencesSection
                id={MenuItems.experiences.id}
                ref={experiencesSectionRef}
            />
            {/* <OurLadsSection id={MenuItems.ourLads.id} ref={ourLadsSectionRef} /> */}
            <OurAppSection id={MenuItems.ourApp.id} ref={ourAppSectionRef} />
            <BenefitsSection
                id={MenuItems.benefits.id}
                ref={benefitsSectionRef}
            />
            {/* <RetailSection
                id={MenuItems.retail.id}
                ref={retailSectionRef}
            /> */}
        </MainLayout>
    );
};

export default IndexPage;
